<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hLHVUw/tc-custom/9781642798746.jpg?1698195342323" alt="This image is the cover for the book Road to Success"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Road to Success
      </h1>
      <p class="bookDescription body article font2">
        <b>Within <i>The Road to Success</i>, Brandon T. Adams and Samantha Rossin share every success and failure to ensure readers have the tools necessary to succeed in the world as it is today.</b><p> Brandon T. Adams and Samantha Rossin, a newly engaged couple, spent 2018 traveling the country on a mission to find the true meaning of success before they tie the knot in marriage. Along the way, they experienced life with individuals who had achieved their own unconventional versions of success. Throughout <i>The Road to Success</i>, Brandon and Samantha bring readers into their own journey as a couple and share with them the lessons they learned that can help one discover their own meaning of success. Each success story and obstacle has its own lessons that provides readers with the wisdom necessary to achieve their own version of success in business, life, and love. After reading <i>The Road to Success</i>, readers find the answers they have been looking for to achieve their own success and happiness in life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brandon T. Adams, Samantha Rossin, Kevin Harrington
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00a09271